@if (asiakkaanTagit().length) {
  <div class="tagi-chipit">
    @for (tagi of asiakkaanTagit(); track tagi.lahde) {
      <span class="tagi-chip" [style.background]="tagi.taustavari" [style.color]="tagi.varikoodi">
        {{ tagi.nimi }} ({{ tagi.pvmTeksti }})
        <mat-icon class="tagi-ikoni" matTooltip="Muokkaa tagin jaksoa" (click)="vaihdaMuokkaus(tagi)">edit</mat-icon>
      </span>
    }
  </div>
}

@if (muokattavaTagi && !muokataanPaattynytta) {
  <ng-container [ngTemplateOutlet]="muokkausPaneeli"></ng-container>
}

@if (paattyneetTagit().length) {
  <div class="paattyneet-otsikko" (click)="vaihdaPaattyneidenNakyvyys()">
    Päättyneet ({{ paattyneetTagit().length }})
    <mat-icon>{{ naytaPaattyneet ? 'expand_less' : 'expand_more' }}</mat-icon>
  </div>
  @if (naytaPaattyneet) {
    <div class="tagi-chipit">
      @for (tagi of paattyneetTagit(); track tagi.lahde) {
        <span class="tagi-chip" [style.background]="tagi.taustavari" [style.color]="tagi.varikoodi">
          {{ tagi.nimi }} ({{ tagi.pvmTeksti }})
          <mat-icon class="tagi-ikoni" matTooltip="Muokkaa tagin jaksoa" (click)="vaihdaMuokkaus(tagi)">edit</mat-icon>
        </span>
      }
    </div>
    @if (muokattavaTagi && muokataanPaattynytta) {
      <ng-container [ngTemplateOutlet]="muokkausPaneeli"></ng-container>
    }
  }
}

<ng-template #muokkausPaneeli>
  <div class="muokkaus-rivi">
    <mat-form-field>
      <mat-label>{{ muokattavaTagi.nimi }} alkaa</mat-label>
      <input matInput [formField]="muokkausLomake.alkuPvm" [matDatepicker]="muokkausAlkuPvmPicker" />
      <mat-datepicker-toggle matSuffix [for]="muokkausAlkuPvmPicker"></mat-datepicker-toggle>
      <mat-datepicker #muokkausAlkuPvmPicker></mat-datepicker>
    </mat-form-field>
    <mat-form-field>
      <mat-label>{{ muokattavaTagi.nimi }} päättyy</mat-label>
      <input matInput [formField]="muokkausLomake.loppuPvm" [matDatepicker]="muokkausLoppuPvmPicker" [min]="muokkausLomake.alkuPvm().value()" />
      <mat-datepicker-toggle matSuffix [for]="muokkausLoppuPvmPicker"></mat-datepicker-toggle>
      <mat-datepicker #muokkausLoppuPvmPicker></mat-datepicker>
      @if (onkoVirhe(muokkausLomake.loppuPvm, 'loppuEnnenAlkua')) {
        <mat-error>Loppupäivä ei voi olla ennen alkupäivää</mat-error>
      } @else if (onkoVirhe(muokkausLomake.loppuPvm, 'paallekkain')) {
        <mat-error>Jakso menee päällekkäin saman tagin toisen jakson kanssa</mat-error>
      }
    </mat-form-field>
    <app-secondary-button (click)="peruutaMuokkaus()" [actionId]="'Peruuta tagin muokkaus: ' + muokattavaTagi.nimi">Peruuta</app-secondary-button>
    <app-secondary-button (click)="poistaJakso(muokattavaTagi)" [actionId]="'Poista tagin jakso: ' + muokattavaTagi.nimi">Poista jakso</app-secondary-button>
    <app-primary-button (click)="valitseMuokkaus()" [actionId]="'Valitse tagin jakso: ' + muokattavaTagi.nimi" [actionContext]="[$any(muokkausLomake().value())]">Valitse</app-primary-button>
  </div>
</ng-template>

@if (!lisaysAuki) {
  <div>
    <app-secondary-button (click)="avaaLisays()" actionId="Avattu muokkausnäkymä: Lisää tagi" additionalClass="mat-elevation-z4" matIcon="add"> Lisää tagi </app-secondary-button>
  </div>
} @else {
  <div class="lisays-lomake">
    <mat-form-field>
      <mat-label>Lisää tagi</mat-label>
      <mat-select [formField]="tagiLomake.tagi">
        @for (tagi of valittavatTagit(); track tagi.avain) {
          <mat-option [value]="tagi.avain">{{ tagi.nimi }}</mat-option>
        }
      </mat-select>
    </mat-form-field>

    <div class="lisays-pvm-rivi">
      <mat-form-field class="lisays-pvm-kentta">
        <mat-label>Aloituspäivämäärä</mat-label>
        <input matInput [formField]="tagiLomake.alkuPvm" [matDatepicker]="tagiPvmPicker" />
        <mat-datepicker-toggle matSuffix [for]="tagiPvmPicker"></mat-datepicker-toggle>
        <mat-datepicker #tagiPvmPicker></mat-datepicker>
      </mat-form-field>
      <mat-form-field class="lisays-pvm-kentta">
        <mat-label>Loppupäivämäärä</mat-label>
        <input matInput [formField]="tagiLomake.loppuPvm" [matDatepicker]="lisaysLoppuPvmPicker" [min]="tagiLomake.alkuPvm().value()" />
        <mat-datepicker-toggle matSuffix [for]="lisaysLoppuPvmPicker"></mat-datepicker-toggle>
        <mat-datepicker #lisaysLoppuPvmPicker></mat-datepicker>
        @if (onkoVirhe(tagiLomake.loppuPvm, 'loppuEnnenAlkua')) {
          <mat-error>Loppupäivä ei voi olla ennen alkupäivää</mat-error>
        } @else if (onkoVirhe(tagiLomake.loppuPvm, 'paallekkain')) {
          <mat-error>Jakso menee päällekkäin saman tagin toisen jakson kanssa</mat-error>
        }
      </mat-form-field>
    </div>

    <div class="lisays-nappirivi">
      <app-secondary-button (click)="peruutaValinta()" actionId="Peruuta tagin lisäys">Peruuta</app-secondary-button>
      <app-primary-button (click)="lisaaTagi()" actionId="Valitse tagi asiakkaalle" [actionContext]="[$any(tagiLomake().value())]">Valitse</app-primary-button>
    </div>
  </div>
}
